let slickDefaults = require('../slick-default/slick-default');
require('./reviews.less');

let size = require('../../modules/size');

jQuery(function() {
    $('.js-slick-reviews').each(function() {
        var $reviewsSlider = $(this);

        $reviewsSlider.slick(
            $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
                slidesToShow: 3,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: size.desktop,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: size.tablet,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            })
        );
    });
});



// WEBPACK FOOTER //
// ./blocks/reviews/reviews.js